import { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { BoxVariantProps } from '../../Box.types';
import { View, ViewStyle } from 'react-native';
import useStyle from '../../../../hooks/useStyle';
import { applyGradientStyles } from './BoxGradient.utils';

function BoxGradient(
  {
    id,
    children,
    gradient = 'accentBackground',
    animatedStyle,
    onLayout,
    testID,
    ...rest
  }: BoxVariantProps<'gradient'>,
  ref: ForwardedRef<View>,
) {
  const style = useStyle<ViewStyle>(rest);
  const Component = animatedStyle ? Animated.View : View;
  const gradientStyle = useMemo(
    () => applyGradientStyles(style, gradient),
    [style, gradient],
  );

  return (
    <Component
      ref={ref}
      id={id}
      style={animatedStyle ? [gradientStyle, animatedStyle] : gradientStyle}
      onLayout={onLayout}
      data-hoverable={true}
      testID={testID}
    >
      {children}
    </Component>
  );
}

export default memo(forwardRef(BoxGradient));
